import React from 'react';
import { Redirect } from 'react-router-dom';
import { ROUTE_ACTIONS } from './constants';

export const getRedirectForAction = ({ action, code }) => {
  if (!action) return null;

  switch (action.toLowerCase()) {
    case ROUTE_ACTIONS.PAYMENT:
      return <Redirect to={code ? `/payments/${code}` : '/payments'} />;
    default:
      return null;
  }
};

export const getFallbackRedirect = () => <Redirect to="/home" />;

